import {
    httpStoreProjectOtherPathologies,
    HttpStoreProjectOtherPathologiesOptions
} from '@/features/projects/http/projects.http'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

// Use temporary interface until the actual HTTP functions are properly implemented
interface UseStoreProjectOtherPathologies {
    urlParams: HttpStoreProjectOtherPathologiesOptions['urlParams']
    options?: UseMutationOptions<
        unknown,
        AxiosError<ErrorResponseData>,
        HttpStoreProjectOtherPathologiesOptions['payload']
    >
}

export const useStoreProjectOtherPathologies = ({urlParams, options}: UseStoreProjectOtherPathologies) => {
    return useMutation({
        mutationFn: payload => httpStoreProjectOtherPathologies({urlParams, payload}),
        ...options
    })
}
